import React from 'react'

const AboutBanner = () => {
    return (
        <section className="main">
            <div className="container">
                <div className="row">
                    <div className="flex flex-row items-center">
                        <div className="w-1/2">
                            <h2>You're in great hands...</h2>
                        </div>
                        <div className="w-1/2">
                            <p className="splurge">Petal is a small boutique design studio dedicated to achieving outstanding results using the latest web technologies. We have over twenty years of experience of web design and development, have also run stunningly successful digital marketing campaigns in some of the toughest market-segments in the world, and have turned small online businesses into multi-million dollar operations. </p>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    )
}

export default AboutBanner